// Scheduler API — správa naplánovaných úloh (vyžaduje is_admin = 'Y')
import { api } from './client'

export const schedulerApi = {
  getJobs:        ()               => api.get('/admin/scheduler/jobs'),
  createJob:      (data)           => api.post('/admin/scheduler/jobs', data),
  updateJob:      (id, data)       => api.put(`/admin/scheduler/jobs/${id}`, data),
  deleteJob:      (id)             => api.delete(`/admin/scheduler/jobs/${id}`),
  runJob:         (id)             => api.post(`/admin/scheduler/jobs/${id}/run`),
  enableJob:      (id)             => api.post(`/admin/scheduler/jobs/${id}/enable`),
  disableJob:     (id)             => api.post(`/admin/scheduler/jobs/${id}/disable`),

  getJobRuns:     (id, params = {}) => api.get(`/admin/scheduler/jobs/${id}/runs${params.limit ? `?limit=${params.limit}` : ''}`),
  deleteJobRuns:  (id)              => api.delete(`/admin/scheduler/jobs/${id}/runs`),
  getRun:         (runId)          => api.get(`/admin/scheduler/runs/${runId}`),
  killRun:        (runId)          => api.post(`/admin/scheduler/runs/${runId}/kill`),

  getJsHandlers:     () => api.get('/admin/scheduler/js-handlers'),
  getPythonScripts:  () => api.get('/admin/scheduler/python-scripts'),
  getStats:          () => api.get('/admin/scheduler/stats'),
}
